import type { PopAccuracyComfortSectionHighlightData } from '../types';
import DesktopHighlights from './DesktopHighlights';
import MobileHighlights from './MobileHighlights';

export interface PopAccuracyComfortSectionHighlightsProps {
  readonly highlights: PopAccuracyComfortSectionHighlightData[];
}

const PopAccuracyComfortSectionHighlights = (
  props: PopAccuracyComfortSectionHighlightsProps,
) => {
  return (
    <>
      <MobileHighlights {...props} />
      <DesktopHighlights {...props} />
    </>
  );
};

export default PopAccuracyComfortSectionHighlights;
